import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
const USER_API = environment.apiUrl;

@Injectable({
    providedIn: 'root'
})
export class CareerService {
    constructor(private http: HttpClient) { }

    getCareerList(query): Observable<any> {
        return this.http.get(USER_API + "career" + query);
    }
    getCareerListWithoutAuth(query): Observable<any> {
        return this.http.get(USER_API + "career/v1?" + query);
    }

    getCareerDetails() {
        return this.http.get('assets/demo/data/career.json')
            .toPromise()
            .then(res => res)
            .then(data => data);
    }
    getHighestSkillJumpDetails() {
        return this.http.get('assets/demo/data/highestskilljumpdata.json')
            .toPromise()
            .then(res => res)
            .then(data => data);
    }

    updateCareer(id, careerData): Observable<any> {
        return this.http.put(USER_API + 'career/' + id, careerData);
    }

    addCareer(careerData): Observable<any> {
        return this.http.post(USER_API + 'career', careerData);
    }

    getCareer(id): Observable<any> {
        return this.http.get(USER_API + "career/" + id);
    }
    getTournamentScoreSkills(): Observable<any> {
        return this.http.get(USER_API + "tournamentscore/skills/" );
    }

}